// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-confirmation {
  font-family: "Rubik", sans-serif !important;
}

.modal-confirmation .modal-title {
  font-family: "Rubik", sans-serif !important;
}

.modal-confirmation .modal-body {
  font-family: "Rubik", sans-serif !important;
}

.modal-button {
  width: 140px;
  padding: 15px !important;
  align-self: flex-end !important;
}

.modal-confirmation-button {
  background-color: #8f033c !important;
  color: rgb(255, 255, 255) !important;
}

.modal-cancel-button {
  background-color: #ffff !important;
  color: #8f033c !important;
}`, "",{"version":3,"sources":["webpack://./src/components/modalconfirmation/ModalConfirmation.css"],"names":[],"mappings":"AAAA;EACE,2CAA2C;AAC7C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,YAAY;EACZ,wBAAwB;EACxB,+BAA+B;AACjC;;AAEA;EACE,oCAAoC;EACpC,oCAAoC;AACtC;;AAEA;EACE,kCAAkC;EAClC,yBAAyB;AAC3B","sourcesContent":[".modal-confirmation {\n  font-family: \"Rubik\", sans-serif !important;\n}\n\n.modal-confirmation .modal-title {\n  font-family: \"Rubik\", sans-serif !important;\n}\n\n.modal-confirmation .modal-body {\n  font-family: \"Rubik\", sans-serif !important;\n}\n\n.modal-button {\n  width: 140px;\n  padding: 15px !important;\n  align-self: flex-end !important;\n}\n\n.modal-confirmation-button {\n  background-color: #8f033c !important;\n  color: rgb(255, 255, 255) !important;\n}\n\n.modal-cancel-button {\n  background-color: #ffff !important;\n  color: #8f033c !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
